/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WarehouseViewModel } from '../../models/warehouse-view-model';

export interface GetWarehouses$Params {
  siteId?: number | null;
}

export function getWarehouses(http: HttpClient, rootUrl: string, params?: GetWarehouses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WarehouseViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getWarehouses.PATH, 'get');
  if (params) {
    rb.query('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WarehouseViewModel>>;
    })
  );
}

getWarehouses.PATH = '/api/v1/Warehouse/GetWarehouses';
